import { render, staticRenderFns } from "./FormAlertComponent.vue?vue&type=template&id=2af420c8&scoped=true&lang=pug"
import script from "./FormAlertComponent.vue?vue&type=script&lang=ts"
export * from "./FormAlertComponent.vue?vue&type=script&lang=ts"
import style0 from "./FormAlertComponent.vue?vue&type=style&index=0&id=2af420c8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af420c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2af420c8')) {
      api.createRecord('2af420c8', component.options)
    } else {
      api.reload('2af420c8', component.options)
    }
    module.hot.accept("./FormAlertComponent.vue?vue&type=template&id=2af420c8&scoped=true&lang=pug", function () {
      api.rerender('2af420c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Alert/FormAlertComponent.vue"
export default component.exports